export default __webpack_public_path__ + "static/3-8722c4bfe3e6e9bfd38de1671b57606e.png";